/* ============================================================
   Notifications redesign — design tokens
   ------------------------------------------------------------
   Raw values from the SecurSpace design system used by the matrix /
   cards / panel. The cell-control accent lives in ChannelControl (so it
   stays swappable in one place); these are the surrounding ink / surface
   / border / radius tokens.
   ============================================================ */

export const INK = {
  heading: '#2E363E',
  body: '#324559',
  secondary: '#5C6771',
  muted: '#7C8793',
};

export const SURFACE = {
  card: '#FFFFFF',
  cool: '#FBFBFF',
};

export const BORDER = {
  default: '#E0E0E0',
  subtle: '#E7E7E7',
};

export const RADIUS = {
  panel: '8px',
  chip: '6px',
  pill: '999px',
};

export const SHADOW_CARD =
  '0 1px 3px rgba(46,54,62,.06), 0 4px 12px rgba(46,54,62,.04)';

// Hard floor: below this viewport width always use the card layout
// (per the design handoff ~760px). Above it, the panel switches matrix → cards
// dynamically based on whether the matrix actually fits the available width.
export const CARD_BREAKPOINT_QUERY = '(max-width:760px)';

// Matrix layout sizing. The category column is fixed; each role × channel column
// needs at least MIN_CHANNEL_COLUMN_WIDTH before the matrix is swapped for cards.
export const CATEGORY_COLUMN_WIDTH = 250;
export const MIN_CHANNEL_COLUMN_WIDTH = 96;
